module.exports = __webpack_public_path__ + "img/main.98fe4e31.png";